var SPIN_PHASE = {
  WAGE: 'WAGE',
  WIN: 'WIN'
};
export default SPIN_PHASE;